if (!customElements.get('massena-waitlist')) {
  customElements.define('massena-waitlist', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.initialized = true;
      this.popup = this.querySelector('.cd-popup');
      this.opener = this.querySelector('[data-waitlist-open]');
      this.status = this.querySelector('[data-waitlist-status]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.opener.addEventListener('click', (event) => {
        event.preventDefault();
        this.popup.classList.add('is-visible');
        this.popup.querySelector('input:not([type="hidden"]), a').focus();
      });
      this.popup.addEventListener('click', (event) => {
        if (event.target === this.popup || event.target.closest('.cd-popup-close')) {
          event.preventDefault();
          this.close();
        }
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
      this.form.addEventListener('submit', (event) => this.submit(event));
    }

    close() {
      this.popup.classList.remove('is-visible');
      this.opener.focus();
    }

    async submit(event) {
      event.preventDefault();
      if (this.pending || this.saved || !this.form.reportValidity()) return;
      this.pending = true;
      this.submitButton.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.hidden = false;
      this.status.textContent = 'Submitting…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);

      try {
        // Preserve the bracketed field names sent by the legacy jQuery request.
        const data = new URLSearchParams(new FormData(this.form));
        const now = new Date();
        const pad = (value) => String(value).padStart(2, '0');
        data.set('datetime', `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`);
        const url = new URL(this.dataset.endpoint);
        url.search = data.toString();
        const response = await fetch(url, {
          method: 'GET',
          redirect: 'follow',
          credentials: 'omit',
          cache: 'no-store',
          signal: controller.signal,
        });
        if (!response.ok) throw new Error('Waitlist request failed');
        const result = await response.json();
        if (!result || result.error || !(result.result === 'success' || result.success === true)) {
          throw new Error('Waitlist was not confirmed');
        }
        this.saved = true;
        this.status.textContent = 'Thank you! You have joined the waiting list.';
      } catch (error) {
        // A failed response does not prove the server failed to save the row.
        // Do not retry automatically or fall back to a second submission.
        this.status.textContent = 'We could not confirm your submission. Please contact us before trying again.';
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.form.removeAttribute('aria-busy');
        this.submitButton.disabled = Boolean(this.saved);
      }
    }
  });
}
